import * as React from 'react';

import PageHeading from 'components/page/page-heading/PageHeading';
import InformationCard from 'components/information-card/InformationCard';
import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import RichTextPreviewModal from 'modules/subcampaigns/components/modals/RichTextPreviewModal';

import { __t, applyTranslations } from 'utils/language';

import './ccm-offer-legal-requirements.scss';

applyTranslations(require('./ccm-offer-legal-requirements.i18n.json'));

type Props = {
  legalRequirements: string | null
};

const MSG_KEY = 'ccm_offer_legal_requirements';

const ActionButtonWithPreviewModal = withModal(ActionButton, {
  modalContent: RichTextPreviewModal
});

const CcmOfferLegalRequirements: React.FC<Props> = ({
  legalRequirements = ''
}): JSX.Element => (
  <div className="ccm-offer-legal-requirements">
    <PageHeading
      heading={__t(`${MSG_KEY}.title`)}
      size="h3"
      margin="none"
      weight="bold"
    />
    <InformationCard
      title=""
      brief={legalRequirements ? __t(`${MSG_KEY}.legal_requirements_brief`) : ''}
      description={legalRequirements}
      previewMode={legalRequirements ? 'external' : 'inline'}
      action={legalRequirements
        ? (
          <ActionButtonWithPreviewModal
            modalContentProps={{
              title: __t(`${MSG_KEY}.legal_requirements`),
              text: legalRequirements
            }}
          >
            {__t(`${MSG_KEY}.buttons.view`)}
          </ActionButtonWithPreviewModal>
        )
        : null
      }
    />
  </div>
);

export default CcmOfferLegalRequirements;
